import axios from "axios"
class Flussonic {
  constructor() {
    this.url = null
  }
  async init() {
    this.url = `${__.platform.baseUrl}/flussonic`
    return this.get()
  }
  async get() {
    const data = await axios
      .get(`${this.url}/streamer/api/v3/streams`, {
        auth: {
          username: "admin",
          password: "admin"
        }
      })
      .then(response => response.data)
      .catch(() => _$.error("An error occured while getting DVR info from Flussonic driver"))

    if (!data) return false
    else return this.collect(data)
  }
  async collect(data) {
    const result = {}
    for (const item of data.streams) {
      if (!item.stats.dvr_info?.ranges[0]?.from) continue
      result[item.name] = {
        name: item.name,
        url: item.stats.url,
        duration: item.stats.dvr_info.ranges[0].duration * 1000,
        from: item.stats.dvr_info.ranges[0].from * 1000
      }
    }
    return result
  }
  async play(payload) {
    const diff = (new Date(payload.data.end) - new Date(payload.data.start)) / 1000
    const start = Math.round(payload.data.start / 1000)

    return `${this.url}/${payload.channel.dvr.name}/video-${start}-${diff}.m3u8`
  }
}

export default new Flussonic()
